import enumeration, {TEnumerationValue} from '../../../../src/Shared/Util/enumeration';

const KeysetType = enumeration(['ALPHANUMERIC', 'SPECIAL_CHARS']);

type TKeysetType = TEnumerationValue<typeof KeysetType>;

export type {TKeysetType};
export {KeysetType as default};
